import * as z from "zod/v4";

export const ReviewResultSchema = z.object({
  risk: z
    .enum(["low", "medium", "high"])
    .describe(
      "The assessed risk level of the return. Low means the return is unlikely to be fraudulent. Medium means the return is likely to be fraudulent. High means the return is definitely fraudulent.",
    ),
  confidence: z
    .enum(["low", "medium", "high"])
    .describe(
      "The confidence in whether the return should be approved or denied. Low means the decision is not very confident. Medium means the decision is somewhat confident. High means the decision is very confident.",
    ),
  approved: z
    .boolean()
    .describe(
      "Indicates whether the return should be approved (true) or denied (false).",
    ),
  explanation: z
    .string()
    .describe(
      "Explanation detailing the reason for the decision made. Start with explaining the decision, then justify that decision by going through the relevant information and evidence.",
    ),
  timelineExplanation: z
    .string()
    .describe(
      "A one line explanation of the decision made. This will be added to the timeline of the return to describe why an action was taken on the return for the merchant to see.",
    ),
});

export const ReviewResultSchemaWithThreadId = ReviewResultSchema.extend({
  threadId: z.string().optional(),
});

export type ReviewResult = z.infer<typeof ReviewResultSchema>;
